import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-automated-user-management-banner',
  templateUrl: './banner.component.html',
})
export class AutomatedUserManagementBannerComponent {
  @Input() buttonText: string;
  @Input() description: string;
  @Input() imageColor: string;
  @Input() imageName: string;
  @Input() title: string;
  @Output() action = new EventEmitter<void>();
}
